import { Publicacion } from '../services/landing/blogService';

export const SAMPLE_BLOG_POSTS: Publicacion[] = [
    {
        id: 101,
        titulo: 'Tendencias de Coworking y Trabajo Colaborativo en Bolivia 2026',
        slug: 'tendencias-coworking-trabajo-colaborativo-bolivia-2026',
        subtitulo: 'El auge del trabajo híbrido, las comunidades de alto impacto y la descentralización del talento profesional en el eje troncal boliviano.',
        contenido: `
<p>El ecosistema laboral en Bolivia ha experimentado una transformación profunda durante los últimos tres años. Lo que comenzó como una respuesta a la flexibilidad del teletrabajo se ha consolidado como una preferencia estructural: los profesionales y empresas ya no buscan simplemente un escritorio y WiFi rápido, sino un <strong>epicentro de conexiones estratégicas</strong>.</p>

<h3>1. Espacios con Propósito y Cultura de Red</h3>
<p>Los espacios de coworking modernos como <strong>Co Marca Group</strong> han demostrado que la interacción espontánea entre emprendedores de distintas áreas (tecnología, agronegocios, finanzas, diseño) genera oportunidades comerciales imposibles de replicar en oficinas aisladas o trabajando desde casa.</p>
<p>Según encuestas internas de nuestra comunidad en Calacoto, más del <strong>68% de los miembros</strong> han cerrado alianzas, contratado proveedores o encontrado clientes directos dentro de las mismas instalaciones.</p>

<h3>2. Infraestructura Tecnológica para el Trabajo Global</h3>
<p>Trabajar con clientes en Estados Unidos, Europa o Centroamérica exige fiabilidad absoluta. Conexiones simétricas con redundancia de fibra óptica, salas insonorizadas para videollamadas con iluminación profesional y accesos digitales 24/7 se han convertido en el estándar mínimo exigido por los equipos ágiles.</p>

<h3>3. Bienestar y Salud Mental en el Trabajo</h3>
<p>La productividad sostenible es la nueva métrica de éxito. La integración de áreas lounge, terrazas al aire libre, café de especialidad de origen boliviano y actividades comunitarias semanales (desde catas de café hasta sesiones de respiración guiada) contrarrestan activamente el agotamiento laboral.</p>

<blockquote>"El futuro no pertenece al trabajo aislado ni a la oficina corporativa rígida. El futuro pertenece a comunidades vibrantes donde cada lunes tienes ganas de ir a construir."</blockquote>

<h3>Conclusión</h3>
<p>En Co Marca seguimos apostando por crear el ecosistema de innovación y coworking más dinámico de Bolivia. Te invitamos a conocer nuestras sedes y ser parte activa de esta transformación colectiva.</p>
        `,
        imagen: null,
        url_imagen: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80',
        categoria: {
            id: 1,
            nombre: 'Startups',
            slug: 'startups',
            descripcion: 'Ecosistema emprendedor y empresas de rápido crecimiento',
            creado_en: '2026-01-01T00:00:00Z',
        },
        autor: 1,
        nombre_autor: 'Alejandro Marca Torrez',
        es_destacado: true,
        estado: 'publicado',
        fecha_publicacion: '2026-03-01T10:00:00Z',
        creado_en: '2026-03-01T10:00:00Z',
        actualizado_en: '2026-03-01T10:00:00Z',
    },
    {
        id: 102,
        titulo: 'Guía Práctica: Cómo Levantar Capital Semilla en Bolivia',
        slug: 'como-levantar-capital-semilla-en-bolivia',
        subtitulo: 'Claves indispensables para fundadores que buscan su primera ronda ángel o pre-semilla en el mercado boliviano.',
        contenido: `
<p>Levantar capital en Bolivia siempre ha sido un reto particular: un mercado de venture capital en maduración, instrumentos regulatorios que requieren creatividad y una cultura inversora tradicionalmente enfocada en bienes raíces o banca.</p>

<p>Sin embargo, en 2025 y 2026 hemos visto más actividad ángel que nunca antes en la historia del país. En esta guía repasamos los 4 pilares fundamentales para presentar una propuesta atractiva ante inversores bolivianos y regionales.</p>

<h3>1. Tracción Verificable sobre Proyecciones Teóricas</h3>
<p>Los inversores locales valoran métricas reales: clientes que pagan recurrentemente, costo de adquisición (CAC) optimizado y un valor de vida del cliente (LTV) saludable. Una idea sin ventas no levanta; un producto modesto con 50 clientes recurrentes sí.</p>

<h3>2. Estructuración Legal Limpia (SAFE y Notas Convertibles)</h3>
<p>Aprende a estructurar rondas utilizando modelos estandarizados como el <em>Simple Agreement for Future Equity (SAFE)</em> de Y Combinator, adaptado con asesoría jurídica local. Esto reduce la fricción de valuación en etapas tempranas.</p>

<h3>3. El Equipo como Mayor Activo</h3>
<p>En etapa temprana, se invierte en personas, no en hojas de cálculo. Un equipo complementario (hacker, hustler, diseñador) con resiliencia demostrada genera mucha mayor confianza en rondas de hasta USD 100,000.</p>
        `,
        imagen: null,
        url_imagen: 'https://images.unsplash.com/photo-1553729459-efe14ef6055d?auto=format&fit=crop&w=1200&q=80',
        categoria: {
            id: 2,
            nombre: 'Inversión',
            slug: 'inversion',
            descripcion: 'Finanzas, rondas de inversión y capital emprendedor',
            creado_en: '2026-01-01T00:00:00Z',
        },
        autor: 2,
        nombre_autor: 'Daniela Ríos Saavedra',
        es_destacado: false,
        estado: 'publicado',
        fecha_publicacion: '2026-02-20T14:30:00Z',
        creado_en: '2026-02-20T14:30:00Z',
        actualizado_en: '2026-02-20T14:30:00Z',
    },
    {
        id: 103,
        titulo: 'Inteligencia Artificial para PyMEs y Startups sin Código',
        slug: 'inteligencia-artificial-para-pymes-startups-sin-codigo',
        subtitulo: 'Herramientas prácticas para automatizar atención al cliente, marketing y flujos de ventas ahorrando hasta 20 horas semanales.',
        contenido: `
<p>La inteligencia artificial ya no es exclusividad de laboratorios de investigación o ingenieros en Silicon Valley. Hoy en día, una PyME boliviana con 3 personas puede competir con la agilidad y precisión de una corporación si implementa las herramientas adecuadas.</p>

<h3>Automatización de WhatsApp y Atención al Cliente</h3>
<p>Integrando modelos LLM con agentes conversacionales en WhatsApp Business, negocios de servicios en La Paz han logrado responder cotizaciones en menos de 30 segundos las 24 horas del día, incrementando la conversión en un 42%.</p>

<h3>Generación de Contenidos y Análisis de Datos Express</h3>
<p>Utilizando herramientas no-code como Make.com y n8n vinculadas a hojas de cálculo y bases de datos, los fundadores pueden generar reportes ejecutivos semanales automáticos y dashboards de rendimiento sin escribir una sola línea de código.</p>
        `,
        imagen: null,
        url_imagen: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=1200&q=80',
        categoria: {
            id: 3,
            nombre: 'Tecnología',
            slug: 'tecnologia',
            descripcion: 'Software, inteligencia artificial e innovación tecnológica',
            creado_en: '2026-01-01T00:00:00Z',
        },
        autor: 3,
        nombre_autor: 'Gabriel Condori Quispe',
        es_destacado: false,
        estado: 'publicado',
        fecha_publicacion: '2026-02-14T09:15:00Z',
        creado_en: '2026-02-14T09:15:00Z',
        actualizado_en: '2026-02-14T09:15:00Z',
    },
    {
        id: 104,
        titulo: 'Nómadas Digitales en La Paz: Guía a 3.600 metros',
        slug: 'nomadas-digitales-la-paz-guia-productividad',
        subtitulo: 'Por qué la Zona Sur de La Paz se está convirtiendo en un secreto a voces para trabajadores remotos de todo el mundo.',
        contenido: `
<p>Con vistas impresionantes del Illimani, una escena gastronómica galardonada a nivel mundial y costos de vida altamente competitivos, La Paz está atrayendo a una comunidad creciente de desarrolladores, diseñadores y consultores remotos globales.</p>

<p>En este artículo analizamos la velocidad de conectividad en Calacoto, las mejores cafeterías para trabajar, cómo adaptarse a la altura mientras mantienes tu productividad al 100%, y la importancia de contar con un coworking con respaldo de energía eléctrica y fibra simétrica.</p>
        `,
        imagen: null,
        url_imagen: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80',
        categoria: {
            id: 4,
            nombre: 'Comunidad',
            slug: 'comunidad',
            descripcion: 'Estilo de vida, trabajo remoto y eventos colectivos',
            creado_en: '2026-01-01T00:00:00Z',
        },
        autor: 4,
        nombre_autor: 'Valentina Cruz Montaño',
        es_destacado: false,
        estado: 'publicado',
        fecha_publicacion: '2026-01-28T16:00:00Z',
        creado_en: '2026-01-28T16:00:00Z',
        actualizado_en: '2026-01-28T16:00:00Z',
    },
    {
        id: 105,
        titulo: 'El Poder del Networking Real: De Conversaciones a Sociedades',
        slug: 'el-poder-del-networking-real-co-marca',
        subtitulo: 'Cómo superar el intercambio superficial de tarjetas de visita y construir alianzas estratégicas duraderas.',
        contenido: `
<p>¿Alguna vez asististe a un evento de networking donde saliste con una pila de tarjetas pero ninguna conexión real? En Co Marca cambiamos el paradigma.</p>
<p>A través de dinámicas estructuradas como las <em>Noches de Founders</em> y <em>Mesas Redondas con Inversores</em>, eliminamos los monólogos y fomentamos la vulnerabilidad profesional: compartir no solo las victorias, sino los desafíos operativos reales que enfrenta cada negocio.</p>
        `,
        imagen: null,
        url_imagen: 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&w=1200&q=80',
        categoria: {
            id: 4,
            nombre: 'Comunidad',
            slug: 'comunidad',
            descripcion: 'Estilo de vida, trabajo remoto y eventos colectivos',
            creado_en: '2026-01-01T00:00:00Z',
        },
        autor: 5,
        nombre_autor: 'Sebastián Alvarado',
        es_destacado: false,
        estado: 'publicado',
        fecha_publicacion: '2026-01-15T11:00:00Z',
        creado_en: '2026-01-15T11:00:00Z',
        actualizado_en: '2026-01-15T11:00:00Z',
    },
    {
        id: 106,
        titulo: 'De la Idea al MVP en 60 Días: Aprendizajes del Bootcamp Nexo',
        slug: 'de-la-idea-al-mvp-en-60-dias-bootcamp-nexo',
        subtitulo: 'Metodología probada para validar hipótesis con clientes reales antes de invertir meses en desarrollo innecesario.',
        contenido: `
<p>El error más común del emprendedor primerizo es enamorarse de la solución en lugar de entender a fondo el problema. En nuestro programa acelerador Nexo, forzamos a los equipos a salir del edificio en la primera semana para entrevistar a al menos 30 usuarios potenciales.</p>
<p>Descubre el framework paso a paso que utilizamos para lanzar productos mínimos viables funcionales en menos de dos meses con presupuesto controlado.</p>
        `,
        imagen: null,
        url_imagen: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1200&q=80',
        categoria: {
            id: 1,
            nombre: 'Startups',
            slug: 'startups',
            descripcion: 'Ecosistema emprendedor y empresas de rápido crecimiento',
            creado_en: '2026-01-01T00:00:00Z',
        },
        autor: 1,
        nombre_autor: 'Alejandro Marca Torrez',
        es_destacado: false,
        estado: 'publicado',
        fecha_publicacion: '2026-01-08T18:00:00Z',
        creado_en: '2026-01-08T18:00:00Z',
        actualizado_en: '2026-01-08T18:00:00Z',
    },
];
